module.exports = __webpack_public_path__ + "img/individuelles_anfertigung.a5e0e2ef.jpg";